module.exports = __webpack_public_path__ + "images/emoji/blue_book.f7c57749a24f970c39bb.png";